import { detectEnvironment } from '@/utils/detectEnvironment';

/**
 * Generates the dashboard API endpoint URL with environment-specific name.
 * For staging: /config/dashboard_staging
 * For production/other: /config/dashboard
 *
 * @param path - Optional additional path to append (e.g., dashboard name)
 * @returns The full dashboard endpoint URL
 */
export const getDashboardApiUrl = (path?: string): string => {
  const basePath =
    detectEnvironment() === 'staging' ? '/config/dashboard_staging' : '/config/dashboard';
  return path?.trim() ? `${basePath}/${path.trim().replace(/^\/+/, '')}` : basePath;
};
